import React, { useState, useEffect, useCallback } from 'react';
import Section from '../Section';
import InsightCard from './InsightCard';
import { Insight, insightsService } from '../../services/insightsService';

interface InsightsPanelProps {
  // Patient profile id — the same id used in the detail URL route.
  patientId: string | number;
}

const InsightsPanel: React.FC<InsightsPanelProps> = ({ patientId }) => {
  const [insights, setInsights] = useState<Insight[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchInsights = useCallback(async () => {
    if (!patientId) return;
    try {
      setLoading(true);
      setError(null);
      const res = await insightsService.getPatientInsights(patientId, {
        review_status: 'all',
        perpage: 100,
      });
      setInsights(res.results);
    } catch (err) {
      console.error('Error fetching insights:', err);
      setError('No se pudieron cargar los insights.');
      setInsights([]);
    } finally {
      setLoading(false);
    }
  }, [patientId]);

  useEffect(() => {
    fetchInsights();
  }, [fetchInsights]);

  return (
    <Section style={{ marginBottom: 0 }}>
      <div style={{ fontWeight: 700, fontSize: 16, color: '#222', marginBottom: 16 }}>Insights del paciente</div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>Cargando insights...</div>
      ) : error ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#e53e3e' }}>{error}</div>
      ) : insights.length === 0 ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
          No hay insights para este paciente.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {insights.map((insight) => (
            <InsightCard key={insight.id} insight={insight} />
          ))}
        </div>
      )}
    </Section>
  );
};

export default InsightsPanel;
